import React from 'react';
import { useSelector } from 'react-redux';
// import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../context/LanguageContext';

import {
  selectItemIds,
  getItemsStatus,
  getItemsError,
} from './postsSlice';

import PostsExcerpt from './PostsExcerpt';

import SingleSlide from '../../components/contentElements/SingleSlide';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import './PostsList.css';


const PostsList = () => {
  const { language } = useLanguage();

  const orderedItemsIds = useSelector(
    selectItemIds
  );

  const itemStatus = useSelector(
    getItemsStatus
  );

  const error = useSelector(
    getItemsError
  );

  /*
   * Add the public SMSE World URL in .env:
   *
   * REACT_APP_SMSE_WORLD_URL=https://...
   *
   * Until then, the button is displayed without
   * navigating to an incorrect URL.
   */
  const platformUrl =
    process.env.REACT_APP_SMSE_WORLD_URL;


  /* =========================================================
     LATEST NEWS
     ========================================================= */

  let newsContent;

  if (itemStatus === 'loading') {
    newsContent = (
      <div className="smse-news-status">
        {language === 'fr'
          ? 'Chargement des actualités...'
          : 'Loading latest news...'}
      </div>
    );
  }

  else if (itemStatus === 'succeeded') {
    if (orderedItemsIds.length === 0) {
      newsContent = (
        <div className="smse-news-status">
          {language === 'fr'
            ? 'Aucune actualité publiée pour le moment.'
            : 'No news has been published yet.'}
        </div>
      );
    } else {
      newsContent = (
        <div className="smse-news-list">
          {orderedItemsIds.map(
            (postId) => (
              <PostsExcerpt
                key={postId}
                postId={postId}
              />
            )
          )}
        </div>
      );
    }
  }

  else if (itemStatus === 'failed') {
    newsContent = (
      <div className="smse-news-status smse-news-error">
        {error ||
          (language === 'fr'
            ? 'Impossible de charger les actualités.'
            : 'Unable to load the latest news.')}
      </div>
    );
  }


  return (
    <>
      <SingleSlide />

      <main className="smse-page">

        {/* ===================================================
            PAGE INTRODUCTION
            =================================================== */}

        <header className="smse-page-intro">

          <span className="smse-page-eyebrow">
            {language === 'fr'
              ? 'Entrepreneuriat • Technologie • Opportunités'
              : 'Entrepreneurship • Technology • Opportunity'}
          </span>

          <h1>
            SMSE World
          </h1>

          <div className="smse-page-line" />

          <p>
            {language === 'fr'
              ? "Un espace numérique conçu pour rapprocher les entrepreneurs, les MPME, les opportunités de marché, les compétences et les acteurs de l'écosystème entrepreneurial."
              : 'A digital space designed to connect entrepreneurs and MSMEs with markets, skills, opportunities and the wider enterprise ecosystem.'}
          </p>

        </header>


        {/* ===================================================
            TWO TABS ONLY
            =================================================== */}

        <div className="smse-tabs-wrapper">

          <Tabs
            defaultActiveKey="presentation"
            id="smse-world-tabs"
            className="smse-tabs"
          >

            {/* ===============================================
                PRESENTATION
                =============================================== */}

            <Tab
              eventKey="presentation"
              title={
                language === 'fr'
                  ? 'Présentation'
                  : 'Presentation'
              }
            >

              <div className="smse-presentation">


                {/* ===========================================
                    GIP HERO
                    =========================================== */}

                <section className="gip-introduction">

                  <div className="gip-introduction-visual">

                    <div className="gip-visual-content">

                      <span className="gip-visual-label">
                        GIP
                      </span>

                      <h2>
                        {language === 'fr'
                          ? 'Grandir, innover et accéder aux opportunités'
                          : 'Grow, Innovate and Access Opportunities'}
                      </h2>

                      <p>
                        {language === 'fr'
                          ? 'Un parcours intégré reliant développement entrepreneurial, technologie, compétences et accès aux marchés.'
                          : 'An integrated pathway connecting enterprise development, technology, skills and market access.'}
                      </p>

                    </div>

                  </div>


                  <div className="gip-introduction-content">

                    <span className="gip-section-label">
                      {language === 'fr'
                        ? 'Une initiative de développement entrepreneurial'
                        : 'An Enterprise Development Initiative'}
                    </span>

                    <h2>
                      {language === 'fr'
                        ? 'Le GIP au sein de l’écosystème SMSE World'
                        : 'GIP within the SMSE World Ecosystem'}
                    </h2>

                    <div className="gip-small-line" />

                    <p>
                      {language === 'fr'
                        ? "Le GIP mobilise une approche intégrée pour accompagner les entrepreneurs et les MPME dans leur parcours de développement. Il relie l'accès aux compétences, l'amélioration des capacités de gestion, la technologie, l'accès aux marchés et les opportunités économiques."
                        : 'GIP uses an integrated approach to support entrepreneurs and MSMEs throughout their development journey. It connects skills, managerial capabilities, technology, market access and economic opportunities.'}
                    </p>

                    <p>
                      {language === 'fr'
                        ? "SMSE World constitue l'environnement numérique permettant de rendre ces ressources, connexions et opportunités plus accessibles aux entreprises et aux acteurs de l'écosystème."
                        : 'SMSE World provides the digital environment through which these resources, connections and opportunities can become more accessible to enterprises and ecosystem actors.'}
                    </p>


                    {platformUrl ? (
                      <a
                        href={platformUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="gip-platform-link"
                      >
                        {language === 'fr'
                          ? 'Explorer la plateforme'
                          : 'Explore the Platform'}

                        <span aria-hidden="true">
                          →
                        </span>
                      </a>
                    ) : (
                      <span className="gip-platform-link gip-platform-link-disabled">
                        {language === 'fr'
                          ? 'Plateforme SMSE World'
                          : 'SMSE World Platform'}

                        <span aria-hidden="true">
                          →
                        </span>
                      </span>
                    )}

                  </div>

                </section>


                {/* ===========================================
                    ACE / MAGEGROUP / SMSE WORLD
                    =========================================== */}

                <section className="gip-ecosystem">

                  <header className="gip-ecosystem-header">

                    <span className="gip-section-label">
                      {language === 'fr'
                        ? 'Une architecture claire'
                        : 'A Clear Partnership Architecture'}
                    </span>

                    <h2>
                      {language === 'fr'
                        ? 'Programme, technologie et plateforme'
                        : 'Programme, Technology and Platform'}
                    </h2>

                    <div className="gip-centred-line" />

                    <p>
                      {language === 'fr'
                        ? "Le dispositif distingue clairement le rôle programmatique d'ACE, le rôle technologique de Magegroup International et la fonction de SMSE World comme environnement numérique."
                        : 'The model clearly distinguishes ACE’s programme role, Magegroup International’s technology role, and SMSE World’s function as the digital environment.'}
                    </p>

                  </header>


                  <div className="gip-ecosystem-grid">


                    <article className="gip-ecosystem-card">

                      <span className="gip-card-number">
                        01
                      </span>

                      <span className="gip-card-label">
                        ACE
                      </span>

                      <h3>
                        {language === 'fr'
                          ? 'Leadership programmatique'
                          : 'Programme Leadership'}
                      </h3>

                      <p>
                        {language === 'fr'
                          ? "ACE porte les objectifs de développement du programme, définit les approches d'accompagnement et mobilise les partenariats nécessaires à sa mise en œuvre."
                          : 'ACE leads the development objectives of the programme, defines the support approaches and mobilises partnerships for implementation.'}
                      </p>

                    </article>


                    <article className="gip-ecosystem-card">

                      <span className="gip-card-number">
                        02
                      </span>

                      <span className="gip-card-label">
                        Magegroup International
                      </span>

                      <h3>
                        {language === 'fr'
                          ? 'Développement technologique'
                          : 'Technology Development'}
                      </h3>

                      <p>
                        {language === 'fr'
                          ? "Magegroup International intervient comme développeur technologique, en concevant et en faisant évoluer les outils numériques qui soutiennent le programme et ses utilisateurs."
                          : 'Magegroup International acts as the technology developer, designing and evolving the digital tools that support the programme and its users.'}
                      </p>

                    </article>


                    <article className="gip-ecosystem-card">

                      <span className="gip-card-number">
                        03
                      </span>

                      <span className="gip-card-label">
                        SMSE World
                      </span>

                      <h3>
                        {language === 'fr'
                          ? 'Environnement numérique'
                          : 'Digital Environment'}
                      </h3>

                      <p>
                        {language === 'fr'
                          ? "SMSE World constitue le point d'accès numérique aux informations, opportunités, ressources, services et connexions proposés aux entrepreneurs et aux MPME."
                          : 'SMSE World serves as the digital gateway to information, opportunities, resources, services and connections for entrepreneurs and MSMEs.'}
                      </p>

                    </article>

                  </div>

                </section>


                {/* ===========================================
                    GIP PATHWAY
                    =========================================== */}

                <section className="gip-pathway">

                  <header className="gip-pathway-header">

                    <span className="gip-section-label">
                      {language === 'fr'
                        ? 'Parcours entrepreneurial'
                        : 'Enterprise Journey'}
                    </span>

                    <h2>
                      {language === 'fr'
                        ? 'De la capacité à l’opportunité'
                        : 'From Capability to Opportunity'}
                    </h2>

                    <div className="gip-centred-line" />

                  </header>


                  <div className="gip-pathway-grid">

                    <article>
                      <span>
                        01
                      </span>

                      <h3>
                        {language === 'fr'
                          ? 'Compétences'
                          : 'Skills'}
                      </h3>

                      <p>
                        {language === 'fr'
                          ? 'Renforcer les compétences entrepreneuriales, techniques et professionnelles.'
                          : 'Strengthen entrepreneurial, technical and professional skills.'}
                      </p>
                    </article>


                    <article>
                      <span>
                        02
                      </span>

                      <h3>
                        {language === 'fr'
                          ? 'Gestion'
                          : 'Management'}
                      </h3>

                      <p>
                        {language === 'fr'
                          ? 'Améliorer les pratiques de gestion, la planification et la performance.'
                          : 'Improve management practices, planning and enterprise performance.'}
                      </p>
                    </article>


                    <article>
                      <span>
                        03
                      </span>

                      <h3>
                        {language === 'fr'
                          ? 'Technologie'
                          : 'Technology'}
                      </h3>

                      <p>
                        {language === 'fr'
                          ? 'Utiliser des solutions numériques adaptées aux besoins des entreprises.'
                          : 'Use digital solutions adapted to enterprise needs.'}
                      </p>
                    </article>


                    <article>
                      <span>
                        04
                      </span>

                      <h3>
                        {language === 'fr'
                          ? 'Marchés'
                          : 'Markets'}
                      </h3>

                      <p>
                        {language === 'fr'
                          ? 'Accéder à de nouveaux clients, réseaux et débouchés.'
                          : 'Reach new customers, networks and market opportunities.'}
                      </p>
                    </article>


                    <article>
                      <span>
                        05
                      </span>

                      <h3>
                        {language === 'fr'
                          ? 'Opportunités'
                          : 'Opportunities'}
                      </h3>

                      <p>
                        {language === 'fr'
                          ? "Créer des passerelles vers l'emploi, les partenariats, le financement et la croissance."
                          : 'Create pathways to employment, partnerships, finance and growth.'}
                      </p>
                    </article>

                  </div>

                </section>


              </div>

            </Tab>


            {/* ===============================================
                LATEST NEWS
                =============================================== */}

            <Tab
              eventKey="news"
              title={
                language === 'fr'
                  ? 'Actualités'
                  : 'Latest News'
              }
            >

              <section className="smse-news">

                <header className="smse-news-header">

                  <span className="gip-section-label">
                    {language === 'fr'
                      ? 'Actualités et opportunités'
                      : 'News and Opportunities'}
                  </span>

                  <h2>
                    {language === 'fr'
                      ? 'Dernières nouvelles'
                      : 'Latest News'}
                  </h2>

                  <div className="gip-centred-line" />

                  <p>
                    {language === 'fr'
                      ? "Suivez les initiatives, opportunités, partenariats et événements de l'écosystème."
                      : 'Follow initiatives, opportunities, partnerships and events from across the ecosystem.'}
                  </p>

                </header>

                {newsContent}

              </section>

            </Tab>

          </Tabs>

        </div>

      </main>
    </>
  );
};


export default PostsList;
